import React, { FC } from "react";

type Props = {
  visibleValue?: string;
};

const CategoryVisibleValue: FC<Props> = ({ visibleValue }) => {
  if (!visibleValue) {
    return null;
  }

  return (
    <span className="classifier-item__visible-value" title={visibleValue}>
      {visibleValue}
    </span>
  );
};

export default CategoryVisibleValue;
